import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, UseFormMethods } from 'react-hook-form';
import {
  addNetworkValidationSchema,
  AddNetworkFormData,
} from '../form-validation';

export type UseFormInitReturn = Pick<
  UseFormMethods<AddNetworkFormData>,
  'control' | 'errors' | 'formState' | 'handleSubmit' | 'reset' | 'trigger' | 'watch'
>;

export const useFormInit = (): UseFormInitReturn => {
  const { control, errors, formState, handleSubmit, reset, trigger, watch } =
    useForm<AddNetworkFormData>({
      defaultValues: {
        interface: '',
        network: '',
        trunked: false,
        trunkedNetworks: [],
      },
      mode: 'all',
      resolver: yupResolver(addNetworkValidationSchema()),
    });

  return {
    control,
    errors,
    formState,
    handleSubmit,
    reset,
    trigger,
    watch,
  };
};
